export { default } from './fbt-fitment';
